export const EVENT_DATA = {
  LOAD: 'EVENT_DATA_LOAD',
  SUCCESS: 'EVENT_DATA_SUCCESS',
  FAIL: 'EVENT_DATA_FAIL',
  LOAD_SUBTENANT: 'SUBTENANT_EVENT_DATA_LOAD',
  SUCCESS_SUBTENANT: 'SUBTENANT_EVENT_DATA_SUCCESS',
  FAIL_SUBTENANT: 'SUBTENANT_EVENT_DATA_FAIL',
};
